import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../Translations';

interface Props {
  label: TPlainTextKey;
}

function Title({ label }: Props) {
  return (
    <Typography variant="bodyMedium" fontWeight="bold" color="dark">
      <T kind={label} />
    </Typography>
  );
}

export default observer(Title);
